/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CustomerUpdateSubmission } from '../../models/customer-update-submission';
import { CustomerUpdateSubmissionForm } from '../../models/customer-update-submission-form';

export interface UpdateDkvCustomer$Params {

/**
 * UUID to identify the svg (tenancy id)
 */
  svgId: string;

/**
 * UUID to identify the customer
 */
  customerId: string;

/**
 * dkvs number to identify the customer
 */
  dkvCustomerNumber: string;
      body: CustomerUpdateSubmissionForm
}

export function updateDkvCustomer(http: HttpClient, rootUrl: string, params: UpdateDkvCustomer$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomerUpdateSubmission>> {
  const rb = new RequestBuilder(rootUrl, updateDkvCustomer.PATH, 'put');
  if (params) {
    rb.path('svgId', params.svgId, {});
    rb.path('customerId', params.customerId, {});
    rb.path('dkvCustomerNumber', params.dkvCustomerNumber, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CustomerUpdateSubmission>;
    })
  );
}

updateDkvCustomer.PATH = '/svgs/{svgId}/customers/{customerId}/dkv-customer-submission/{dkvCustomerNumber}';
